import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { formatUsd } from '../lib/format';

interface Photo {
  uuid: string;
  src: string;
  title: string;
  photographer: string;
  price_base_cents: number;
  slug: string;
  is_active: number;
}

export function PhotosList() {
  const [photos, setPhotos] = useState<Photo[]>([]);

  useEffect(() => {
    api
      .get<{ photos: Photo[] }>('/api/admin/photos')
      .then((d) => setPhotos(d.photos))
      .catch(console.error);
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 28, fontWeight: 400 }}>Photos</h1>
        <Link
          to="/photos/new"
          style={{
            padding: '10px 16px',
            background: '#1a1a1a',
            color: '#fff',
            borderRadius: 6,
            fontSize: 13,
          }}
        >
          Add photo
        </Link>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
          gap: 16,
          marginTop: 24,
        }}
      >
        {photos.map((p) => (
          <Link
            key={p.uuid}
            to={`/photos/${p.uuid}`}
            style={{
              background: '#fff',
              border: '1px solid #e5e5e5',
              borderRadius: 8,
              overflow: 'hidden',
              textDecoration: 'none',
              color: 'inherit',
              opacity: p.is_active ? 1 : 0.5,
            }}
          >
            <img
              src={p.src}
              alt={p.title}
              style={{ width: '100%', height: 160, objectFit: 'cover', display: 'block' }}
            />
            <div style={{ padding: 12 }}>
              <div style={{ fontWeight: 500 }}>{p.title}</div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                {p.photographer} · {formatUsd(p.price_base_cents)} base
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
